import React from 'react';
import NegotiationStatusBadge from '../NegotiationStatusBadge';
import RoomPanel from './RoomPanel';
import { formatPrice } from '../../utils/formatters';
import {
  activeRounds,
  getPartnerDisplayStatus,
  PARTNER_STATUS,
} from '../../utils/negotiationStatus';

const lastPrice = line =>
  line.statusLabel === PARTNER_STATUS.ACCEPTED
    ? line.acceptedPrice
    : activeRounds(line).slice(-1)[0]?.price;

// Alpha lines of the partner (be#455 K-2): each has its own rounds, turn and
// accept. The picked line drives AdjustPanel and the round history.
const LineSelector = ({ lines = [], selectedId, onSelect, unit }) => (
  <RoomPanel
    title='Alpha lines'
    description='Each line is negotiated and accepted on its own'
    icon='ri-list-check-2'
  >
    <div className='neg-lines' role='listbox' aria-label='Alpha lines'>
      {lines.map(line => {
        const active = String(line.id) === String(selectedId);
        return (
          <button
            key={line.id}
            type='button'
            role='option'
            aria-selected={active}
            className={`neg-line${active ? ' is-active' : ''}`}
            onClick={() => onSelect(line.id)}
          >
            <span className='neg-line__label'>{line.label}</span>
            <span className='neg-line__meta'>
              <span className='text-muted'>
                {formatPrice(lastPrice(line), unit)}
              </span>
              <NegotiationStatusBadge
                code={getPartnerDisplayStatus(line)}
                size='sm'
              />
            </span>
          </button>
        );
      })}
    </div>
  </RoomPanel>
);

export default LineSelector;
